import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import Swal from 'sweetalert2';
import { AppyUser } from '../../../../core/model/v2/AppyUser';
import { Patient } from '../../../../core/models/patient/patient';
import { PaymentProfile } from '../../../../core/models/UserPaymentProfile/userPaymentProfile';
import { PatientService } from '../../../../core/services/v2/patient.service';
import { UserService } from '../../../../core/services/v2/user.service';
import { UtilsService } from '../../../../core/services/v2/utils.service';
import { CreditCardComponent } from '../../../../market-place/market-place-home/product-checkout/credit-card/credit-card.component';
import { WindowLoaderService } from '../../../../shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-patient-credit-card',
  templateUrl: './patient-credit-card.component.html',
  styleUrls: ['./patient-credit-card.component.scss']
})
export class PatientCreditCardComponent implements OnInit {
  @Input() patientProfile: Patient;
  @Input() editEnable: boolean = true;
  @Input() isParams = false;
  @Input() patientId: string;
  @Output() toggleEditEvent = new EventEmitter();
  user: AppyUser;
  creditCards: PaymentProfile[];
  customerProfileId: string;
  constructor(
    public dialog: MatDialog,
    private userService: UserService,
    private loaderService: WindowLoaderService,
    private patientService: PatientService,
    private changeDetectorRefs: ChangeDetectorRef,
    private utils: UtilsService,
  ) { }

  ngOnInit() {
    this.getUser();
  }

  private async getUser() {
    this.userService.getUserDetails().subscribe((userDetail) => {
      this.user = userDetail;
      this.customerProfileId = this.user.authorizeNetUserID;
      this.GetPaymentInformation();
    });
  }

  private GetPaymentInformation() {
    if (this.user.authorizeNetUserID) {
      this.loaderService.blockWithLoader(this.userService.GetPaymentInformation(this.user.authorizeNetUserID)).subscribe(data => {
        console.log("Payment Information", data);
        console.log("Credit Cards", data.profile.paymentProfiles);
        this.creditCards = data.profile.paymentProfiles;
        this.customerProfileId = data.profile.customerProfileId
      });
    }
  }

  addCreditCard(): void {
    const dialogRef = this.dialog.open(CreditCardComponent, {
      // height: '45%',
      width: '748px',
      disableClose: true,
      data: this.customerProfileId ? this.customerProfileId : null
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res && res.data && res.data.resultStatus) {
        if (res.data.resultStatus.isSuccess) {
          this.utils.showMessageSnackBar('Credit card saved successfully.');
        }
        else {
          this.utils.showMessageSnackBar(res.data.resultStatus.message, true);
        }
      }
      this.GetPaymentInformation();
    });
  }

  deleteCreditCard(customerPaymentProfileId: string) {
    if (this.customerProfileId) {
      Swal.fire({
        title: `Remove Favorite`,
        text: `Are you sure want to remove this credit card?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Remove!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.loaderService.blockWithLoader(this.userService.DeletePaymentInformation(this.customerProfileId, customerPaymentProfileId)).subscribe(data => {
            this.GetPaymentInformation();
          });
        }
      })

    }
  }

}
